import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function CloseOrangeIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      width={width || 7.707}
      height={height || 7.707}
      viewBox="0 0 7.707 7.707"
    >
      <path
        data-name="Path 10025"
        d="M7.354 1.059l-.7-.705-2.8 2.795L1.059.354l-.705.705 2.795 2.795-2.795 2.8.705.7 2.795-2.8 2.8 2.8.7-.7-2.8-2.8z"
        fill={color || "#fb972e"}
        stroke={color || "#fb972e"}
        strokeWidth={0.5}
      />
    </svg>
  );
}
